import React, { useEffect } from 'react';
import Dialog from "../../components/controls/Dialog";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import * as featureService from '../../services/featureService';
import Input from '../../components/controls/Input';
import Select from '../../components/controls/Select';
import { useForm } from '../../components/useForm';
import useAlert from '../../components/useAlert';

const featureTypes = ["BOOL", "STRING", "NUMBER"];

const initialFValues = {
    id: '',
    type: 'STRING',
    description: '',
    defaultValue: ''
}

const FeatureDialog = (props) => {
    const { open, selectedRow, getFeatures } = props;

    const {
        values,
        setValues,
        errors,
        handleInputChange,
        handleClose,
        handleError
    } = useForm(initialFValues, props);

    useEffect(() => {
        if (open)
            handleAlertClose();
        if (selectedRow)
            setValues({
                ...selectedRow
            });
        else
            setValues(initialFValues);
        //eslint-disable-next-line
    }, [selectedRow, open])

    const {
        Alert,
        status,
        showSuccess,
        showError,
        handleAlertClose
    } = useAlert();

    const submit = () => {
        if (validate()) {
            if (selectedRow)
                featureService.updateFeature(selectedRow.id, values)
                    .then(() => {
                        showSuccess();
                        handleClose();
                        getFeatures();
                    })
                    .catch(error => {
                        showError(error.response?.data?.message || "Error updating Feature");
                        handleError(error.response?.data?.fields);
                    });
            else
                featureService.createFeature(values)
                    .then(() => {
                        showSuccess();
                        handleClose();
                        getFeatures();
                    })
                    .catch(error => {
                        showError(error.response?.data?.message || "Error creating Feature");
                        handleError(error.response?.data?.fields);
                    });
        }
    };

    const validate = () => {
        let temp = {}
        temp.id = values.id ? "" : "ID is required";
        temp.defaultValue = values.defaultValue ? "" : "Default value is required";
        return Object.values(temp).every(x => x === '');
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <Dialog
                title={selectedRow ? "Edit Feature" : "Create new Feature"}
                open={open}
                handleClose={handleClose}>
                <DialogContent>
                    <Input
                        {...(selectedRow && { disabled: true })}
                        label="Feature ID"
                        name="id"
                        defValue={values.id}
                        onChange={handleInputChange}
                        error={errors.id}
                    />
                    <Select
                        label="Type"
                        name="type"
                        defValue={values.type}
                        onChange={handleInputChange}
                        options={featureTypes}
                    />
                    <Input
                        label="Description"
                        name="description"
                        defValue={values.description}
                        onChange={handleInputChange}
                        error={errors.description}
                    />
                    <Input
                        label="Default Value"
                        name="defaultValue"
                        defValue={values.defaultValue}
                        onChange={handleInputChange}
                        error={errors.defaultValue}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={submit}>Save</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default FeatureDialog;
